import DateRangePicker from './js/DateRangePicker';

export default DateRangePicker;
